/*
 * Status badge — DESIGN.md §2 semantic colours + §4 pill radius (20px).
 * Invoice statuses: draft (gris), sent (bleu/info), paid (vert), overdue (ambre).
 */
const TONES = {
  neutral: { color: '#6B6776', bg: '#F1EEF8' },
  success: { color: 'var(--color-success)', bg: 'var(--color-success-bg)' },
  warning: { color: 'var(--color-warning)', bg: 'var(--color-warning-bg)' },
  danger: { color: 'var(--color-danger)', bg: 'var(--color-danger-bg)' },
  info: { color: 'var(--color-info)', bg: 'var(--color-info-bg)' },
}

// Maps an invoice status to a tone. Kept here so every list/detail agrees.
export const INVOICE_STATUS_TONE = {
  draft: 'neutral',
  sent: 'info',
  paid: 'success',
  overdue: 'warning',
  cancelled: 'danger',
}

export default function Badge({ tone = 'neutral', children, style }) {
  const t = TONES[tone] || TONES.neutral
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: '4px 11px', borderRadius: 'var(--radius-pill)',
        fontSize: 12, fontWeight: 600, lineHeight: 1.4,
        color: t.color, background: t.bg,
        ...style,
      }}
    >
      {children}
    </span>
  )
}
